import { alpha } from '@mui/material/styles';
import { Box, Button, IconButton, Stack, Typography } from '@mui/material';
import React from 'react';
import Iconify from '../../components/Iconify';

// Bandeau d'accent en haut (couleur primaire)
const AccentBar = () => (
  <Box
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: 3,
      background: (theme) =>
        `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.primary.light})`,
      borderRadius: '8px 8px 0 0',
    }}
  />
);

export default function HomeInfoBanniereModal({ onClose }) {
  return (
    <Box sx={{ position: 'relative' }}>
      <AccentBar />
      <IconButton
        onClick={onClose}
        title="Fermer"
        size="small"
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          zIndex: 1,
          color: 'grey.600',
          bgcolor: (theme) => alpha(theme.palette.grey[500], 0.08),
          '&:hover': {
            bgcolor: (theme) => alpha(theme.palette.grey[500], 0.16),
            color: 'grey.800',
          },
          transition: 'background-color 0.2s ease, color 0.2s ease',
        }}
      >
        <Iconify icon="eva:close-fill" width={18} />
      </IconButton>
      <Stack spacing={1.5} px={2} pt={2.5} pb={2} sx={{ pr: 4 }}>
        <Stack direction="row" alignItems="flex-start" spacing={1.25}>
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: 1.5,
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.12),
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <Iconify icon="eva:file-text-outline" width={20} sx={{ color: 'primary.main' }} />
          </Box>
          <Stack spacing={0.25} sx={{ minWidth: 0 }}>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 700,
                color: 'grey.800',
                lineHeight: 1.35,
                fontSize: '0.9rem',
              }}
            >
              Les services de l’API-ZF sont désormais dématérialisés
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontWeight: 500,
                color: 'grey.600',
                lineHeight: 1.4,
                fontSize: '0.8rem',
              }}
            >
              Effectuez nos procédures en un clic !
            </Typography>
          </Stack>
        </Stack>
        <Button
          LinkComponent="a"
          href="https://services.apizf.tg/"
          target="_blank"
          rel="noopener noreferrer"
          variant="contained"
          color="primary"
          size="small"
          fullWidth
          endIcon={<Iconify icon="eva:diagonal-arrow-right-up-outline" width={16} />}
          sx={{
            py: 1,
            borderRadius: 1.5,
            fontWeight: 600,
            fontSize: '0.8rem',
            textTransform: 'none',
            boxShadow: (theme) =>
              theme.customShadows?.primary || `0 2px 8px ${alpha(theme.palette.primary.main, 0.35)}`,
            '&:hover': {
              boxShadow: (theme) =>
                theme.customShadows?.primary || `0 4px 12px ${alpha(theme.palette.primary.main, 0.45)}`,
            },
            transition: 'box-shadow 0.2s ease, transform 0.2s ease',
            '&:active': { transform: 'scale(0.98)' },
          }}
        >
          Démarrer une démarche en ligne
        </Button>
      </Stack>
    </Box>
  );
}
